// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3RKzK","header":"ClearentDisclaimer_header__3VT-I","inner":"ClearentDisclaimer_inner__2Uixb"};